// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main{
    height: 70vh;
    width: 30%;
    position: absolute;
    margin: 1% 0% 0 0%;
    left: 40%;   
}
.resetlink{
  color: #03b4c6;
  margin-left: '30%';
  cursor:'pointer'; 
}

.resetlink:hover{
color: black;
}
.inp
{
    width: 90%;
    height: auto;
    border: 1px solid rgb(175, 175, 175);
    border-radius: 1vh;
    margin: 2%;
    padding: 3%;
}
.inp:hover{
    border: 2px solid #03b4c6;

}
.btn
{
  width:20vw;
    padding: 3% 6% 3% 6%;
    background-color: white;
    font-weight: bold;
    color: #03b4c6;
    font-family: sans-serif;
    border: 2px solid #03b4c6;
    border-radius: 1vh;
    margin: 3% 0 0% 10%;
    text-align: center;
    word-wrap: break-word;
    
}
.btn:hover{
    background-color: #03b4c6;
    color:white ;
}

/* Admin NavBar */
.UserDropdown
{
    font-size: 20px;
    color: #03b4c6;
}
.UserDropdown:hover
{
    color: white !important;
    background-color:#03b4c6;
}
 
   .dropdown-container {
    position: relative;
    display: inline-block;
    /* background-color: #03b4c6;
    border: 1px solid #2f3030; */
  }
    
  .dropdown-menu_ {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    background-color: #edffff;
    border: 1px solid #03b4c6;
    /* Your styles for the dropdown menu */
  }
  
  .course-text {
    display: block;
    white-space: normal;
    overflow-wrap: break-word;
  }
  
  .overlay1122,.overlay1133 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* semi-transparent dark background */
    z-index: 9998;
  }
  
  
  .popup{
    height: 70vh;
    width: 100%;
    background-color: rgb(255, 255, 255);
    position: absolute; 
    overflow-x:inherit;
    overflow-y:auto;
    padding-left: 5%;
    border-radius: 2vh;
    /* transition: 2s ease;
     */
}
.popup-header{
    display: flex;
    justify-content: space-between;
    padding: 0 30px 0 15px; 
}

.SignUP-avatar-upload {
  display: flex;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #e0e0e0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.SignUP-avatar-upload img {
  max-width: 100%;
  max-height: 100%;
}
.Signupbtn
{
  border: 0;
  border-radius: 0;
  
}
 

.Navbar-Right-Aligned
{
  justify-content: flex-end;
  /* padding-right: 3%; */
}
.user-profile-dropdown
{
  border:1px  solid #03b4c6;
  background-color:#edffff;
  margin-left: -80%;
}
.pageLogo
{
   width: 15%; height: 3%;
}
@media only screen and (max-width: 1000px)
{
  .pageLogo{
    width: 30%;
  }
  .main
  {     
      margin-left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 95%;
      left: 0;
      margin-left: 2%;
  }
  .popup
  {
    padding-left: 0;
    margin-left: 1%;
    margin-right: 1%;
  }
  .btn{
    width: 80%;
  }
  .user-profile-dropdown
  {
    width: 80%;
    margin: 0;
  }
}




.modal-content{
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.AttendClassButton{

  background-color: #03b4c6;
  color: white;
  font-weight: normal;
  border: none;
  border-radius: 3vh;
  width: 50%;
  padding: 2vh;
  font-size: large;
}
.AttendClassDropdown
{
  width: 50%;
  height: auto;
  padding: 2vh;
  border: none;
  margin: 2vh;

  
}
.AttendClassDropdown option {
  max-width: 100%; /* Ensures options don't exceed dropdown's width */
  white-space: nowrap; /* Prevents text wrapping */
  overflow: hidden; /* Hides overflowing text */
  text-overflow: ellipsis; /* Adds ellipsis (...) for overflowing text */
  display: inline-block; /* Necessary for text-overflow to work */
}
.dropdown-menu-scrollable {
  max-height: 300px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/Nav.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;AACA,YAAY;AACZ;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;IACI,yBAAyB;;AAE7B;AACA;;EAEE,UAAU;IACR,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,iBAAiB;AACjB;;IAEI,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,uBAAuB;IACvB,wBAAwB;AAC5B;;GAEG;IACC,kBAAkB;IAClB,qBAAqB;IACrB;gCAC4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,qCAAqC;IAC3E,aAAa;EACf;;;EAGA;IACE,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;MACE;AACN;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,gBAAgB;;AAElB;;;AAGA;;EAEE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;;GAEG,UAAU,EAAE,UAAU;AACzB;AACA;;EAEE;IACE,UAAU;EACZ;EACA;;MAEI,cAAc;MACd,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,UAAU;MACV,OAAO;MACP,eAAe;EACnB;EACA;;IAEE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,SAAS;EACX;AACF;;;;;AAKA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;;;AAGb;AACA;EACE,eAAe,EAAE,kDAAkD;EACnE,mBAAmB,EAAE,2BAA2B;EAChD,gBAAgB,EAAE,2BAA2B;EAC7C,uBAAuB,EAAE,6CAA6C;EACtE,qBAAqB,EAAE,wCAAwC;AACjE;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".main{\n    height: 70vh;\n    width: 30%;\n    position: absolute;\n    margin: 1% 0% 0 0%;\n    left: 40%;   \n}\n.resetlink{\n  color: #03b4c6;\n  margin-left: '30%';\n  cursor:'pointer'; \n}\n\n.resetlink:hover{\ncolor: black;\n}\n.inp\n{\n    width: 90%;\n    height: auto;\n    border: 1px solid rgb(175, 175, 175);\n    border-radius: 1vh;\n    margin: 2%;\n    padding: 3%;\n}\n.inp:hover{\n    border: 2px solid #03b4c6;\n\n}\n.btn\n{\n  width:20vw;\n    padding: 3% 6% 3% 6%;\n    background-color: white;\n    font-weight: bold;\n    color: #03b4c6;\n    font-family: sans-serif;\n    border: 2px solid #03b4c6;\n    border-radius: 1vh;\n    margin: 3% 0 0% 10%;\n    text-align: center;\n    word-wrap: break-word;\n    \n}\n.btn:hover{\n    background-color: #03b4c6;\n    color:white ;\n}\n\n/* Admin NavBar */\n.UserDropdown\n{\n    font-size: 20px;\n    color: #03b4c6;\n}\n.UserDropdown:hover\n{\n    color: white !important;\n    background-color:#03b4c6;\n}\n \n   .dropdown-container {\n    position: relative;\n    display: inline-block;\n    /* background-color: #03b4c6;\n    border: 1px solid #2f3030; */\n  }\n    \n  .dropdown-menu_ {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 999;\n    background-color: #edffff;\n    border: 1px solid #03b4c6;\n    /* Your styles for the dropdown menu */\n  }\n  \n  .course-text {\n    display: block;\n    white-space: normal;\n    overflow-wrap: break-word;\n  }\n  \n  .overlay1122,.overlay1133 {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* semi-transparent dark background */\n    z-index: 9998;\n  }\n  \n  \n  .popup{\n    height: 70vh;\n    width: 100%;\n    background-color: rgb(255, 255, 255);\n    position: absolute; \n    overflow-x:inherit;\n    overflow-y:auto;\n    padding-left: 5%;\n    border-radius: 2vh;\n    /* transition: 2s ease;\n     */\n}\n.popup-header{\n    display: flex;\n    justify-content: space-between;\n    padding: 0 30px 0 15px; \n}\n\n.SignUP-avatar-upload {\n  display: flex;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  text-align: center;\n  cursor: pointer;\n  overflow: hidden;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.SignUP-avatar-upload img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.Signupbtn\n{\n  border: 0;\n  border-radius: 0;\n  \n}\n \n\n.Navbar-Right-Aligned\n{\n  justify-content: flex-end;\n  /* padding-right: 3%; */\n}\n.user-profile-dropdown\n{\n  border:1px  solid #03b4c6;\n  background-color:#edffff;\n  margin-left: -80%;\n}\n.pageLogo\n{\n   width: 15%; height: 3%;\n}\n@media only screen and (max-width: 1000px)\n{\n  .pageLogo{\n    width: 30%;\n  }\n  .main\n  {     \n      margin-left: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 95%;\n      left: 0;\n      margin-left: 2%;\n  }\n  .popup\n  {\n    padding-left: 0;\n    margin-left: 1%;\n    margin-right: 1%;\n  }\n  .btn{\n    width: 80%;\n  }\n  .user-profile-dropdown\n  {\n    width: 80%;\n    margin: 0;\n  }\n}\n\n\n\n\n.modal-content{\n  width: 40%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.AttendClassButton{\n\n  background-color: #03b4c6;\n  color: white;\n  font-weight: normal;\n  border: none;\n  border-radius: 3vh;\n  width: 50%;\n  padding: 2vh;\n  font-size: large;\n}\n.AttendClassDropdown\n{\n  width: 50%;\n  height: auto;\n  padding: 2vh;\n  border: none;\n  margin: 2vh;\n\n  \n}\n.AttendClassDropdown option {\n  max-width: 100%; /* Ensures options don't exceed dropdown's width */\n  white-space: nowrap; /* Prevents text wrapping */\n  overflow: hidden; /* Hides overflowing text */\n  text-overflow: ellipsis; /* Adds ellipsis (...) for overflowing text */\n  display: inline-block; /* Necessary for text-overflow to work */\n}\n.dropdown-menu-scrollable {\n  max-height: 300px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
